var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ba-card-breadcrumb ba-card"},[_c('nav',{staticClass:"ba-breadcrumb"},[_c('ol',{staticClass:"ba-breadcrumb-ol"},_vm._l((_vm.showBreadcrumb(_vm.items)),function(item,k){return _c('li',{key:k,staticClass:"ba-breadcrumb-item"},[_c('b-link',{attrs:{"to":item.href},domProps:{"innerHTML":_vm._s(_vm.$t(item.text))}})],1)}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }